import * as React from 'react'

const SvgArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.369 10.369l-4.744 4.737V1.25h-1.25v13.856L4.631 10.37l-.881.881L10 17.5l6.25-6.25-.881-.881z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowDownIcon
